import { Remoting_buildProxy_64DC51C } from "./fable_modules/Fable.Remoting.Client.7.32.0/./Remoting.fs.js";
import { RemotingModule_createApi, RemotingModule_withRouteBuilder } from "./fable_modules/Fable.Remoting.Client.7.32.0/Remoting.fs.js";
import { routeBuilder } from "../Bfs.Web.Shared.FSharp/Routing.fs.js";
import { Benachrichtigungen_IBenachrichtigungenService_$reflection, Settings_ISettingsService_$reflection } from "../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";

export const Settings = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(routeBuilder, RemotingModule_createApi()), Settings_ISettingsService_$reflection());

export const Benachrichtigungen = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(routeBuilder, RemotingModule_createApi()), Benachrichtigungen_IBenachrichtigungenService_$reflection());

//# sourceMappingURL=Service.fs.js.map
